import { atom } from 'jotai'

export type RoomTableColType =
  | 'roomName'
  | 'wing'
  | 'floor'
  | 'roomType'
  | 'selectEnabled'
  | 'memo'
  | 'registerLimitAt'
  | 'publishApplication'
  | 'orderApplication'
  | 'contractorName'
  | 'contractorConfirmed'
  | 'emailSentTime'
  | 'agreementRequestEmailSentTime'
  | 'registrationStatus'
  | 'proxyRegister'

type Input = {
  sortItem:
    | { col: RoomTableColType; type: 'asc' | 'desc' }
    | { col: 'selectMaster'; selectMasterId: string; type: 'asc' | 'desc' }
    | undefined
}

const storeValues = atom<Input>({
  sortItem: undefined,
})
export const roomTableSortStore = { state: storeValues } as const
